module.exports = __webpack_public_path__ + "media/images/svg/logos_campanya-8dc3cab176b646c05ea2d022a3d6fc8f.svg";